import React, { useEffect } from 'react';
import brasaoBrasil from '@/assets/brasao-brasil.webp';
import brasaoMagistral from '@/assets/Logo-OSMTH-D.webp';
import brasaoRJ from '@/assets/brasao-rj.webp';

import imgAlbino from '@/assets/Albino.webp';
import imgFernando from '@/assets/fernando.webp';
import imgSideni from '@/assets/Sideni.webp';
import imgAparecida from '@/assets/aparecida.webp';
import imgRegente from '@/assets/Regente de Comendadoria.webp';
import imgRaymond from '@/assets/Raymond.webp';
import cruzTemplaria from '@/assets/cruz-templaria.svg';
import Lenis from 'lenis';
import { FloatingNav } from '@/components/FloatingNav';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselDots,
} from "@/components/ui/carousel";
import { VimeoPlayer } from '@/components/VimeoPlayer';
import { BackgroundMusic } from '@/components/BackgroundMusic';
const CountdownTimer = React.lazy(() => import('@/components/CountdownTimer').then(module => ({ default: module.CountdownTimer })));
import { useTranslation } from 'react-i18next';



const Index = () => {
  const { t } = useTranslation();





  const navItems = [
    { name: t('nav.inicio', "Início"), link: "#hero", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg> },
    { name: t('nav.encontro', "O Encontro"), link: "#sobre", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg> },
    { name: t('nav.autoridades', "Autoridades"), link: "#autoridades", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg> },
    { name: t('nav.programacao', "Programação"), link: "#programacao", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg> },
    { name: t('nav.dressCode', "Dress Code"), link: "#dresscode", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z" /></svg> },
    { name: t('nav.heraldica', "Heráldica"), link: "#heraldica", icon: <svg width="20" height="20" viewBox="0 0 90 120" fill="currentColor"><path d="M38 8 L52 8 L52 30 L82 30 L82 42 L52 42 L52 62 L72 62 L72 74 L52 74 L52 112 L38 112 L38 74 L18 74 L18 62 L38 62 L38 42 L8 42 L8 30 L38 30 Z" /></svg> },
    { name: t('nav.coordenacao', "Coordenação"), link: "#coordenacao", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg> },
  ];

  useEffect(() => {
    // ── Cursor Script ──
    const dot = document.getElementById('dot');
    const ring = document.getElementById('ring');

    const moveCursor = (e: MouseEvent) => {
      if (dot) {
        dot.style.left = e.clientX + 'px';
        dot.style.top = e.clientY + 'px';
      }
      if (ring) {
        setTimeout(() => {
          ring.style.left = e.clientX + 'px';
          ring.style.top = e.clientY + 'px';
        }, 50);
      }
    };

    window.addEventListener('mousemove', moveCursor);

    // ── Intersection Observer for Reveals ──
    const observerOptions = { threshold: 0.15 };
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-active');
        }
      });
    }, observerOptions);

    const revealItems = document.querySelectorAll('.reveal-item');
    revealItems.forEach((item) => revealObserver.observe(item));



    // ── Hero Canvas Effects (Atmospheric Embers) ──
    const bgCanvas = document.getElementById('bg-canvas') as HTMLCanvasElement;
    const flameCanvas = document.getElementById('flame-canvas') as HTMLCanvasElement;

    if (bgCanvas && flameCanvas) {
      const bgCtx = bgCanvas.getContext('2d');
      const flCtx = flameCanvas.getContext('2d');

      if (bgCtx && flCtx) {
        let w = window.innerWidth;
        let h = window.innerHeight;
        bgCanvas.width = w;
        bgCanvas.height = h;
        flameCanvas.width = w;
        flameCanvas.height = 320;

        const particles: any[] = [];
        const particleCount = 40;

        for (let i = 0; i < particleCount; i++) {
          particles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            vx: (Math.random() - 0.5) * 0.4,
            vy: -Math.random() * 0.5 - 0.2,
            size: Math.random() * 2 + 0.5,
            opacity: Math.random() * 0.4 + 0.1,
          });
        }

        const animate = () => {
          bgCtx.clearRect(0, 0, w, h);
          bgCtx.fillStyle = '#c9a84c'; // Gold color for embers

          particles.forEach((p) => {
            p.x += p.vx;
            p.y += p.vy;
            if (p.y < -10) p.y = h + 10;
            if (p.x < -10) p.x = w + 10;
            if (p.x > w + 10) p.x = -10;

            bgCtx.globalAlpha = p.opacity;
            bgCtx.beginPath();
            bgCtx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
            bgCtx.fill();
          });

          // Subtle "flame pulse" on the bottom canvas
          flCtx.clearRect(0, 0, w, 320);
          const gradient = flCtx.createLinearGradient(0, 320, 0, 0);
          const pulse = Math.sin(Date.now() * 0.001) * 0.05;
          gradient.addColorStop(0, `rgba(139, 26, 26, ${0.4 + pulse})`);
          gradient.addColorStop(0.6, 'rgba(139, 26, 26, 0)');
          flCtx.fillStyle = gradient;
          flCtx.fillRect(0, 0, w, 320);

          requestAnimationFrame(animate);
        };

        animate();

        window.addEventListener('resize', () => {
          w = window.innerWidth;
          h = window.innerHeight;
          bgCanvas.width = w;
          bgCanvas.height = h;
          flameCanvas.width = w;
          flameCanvas.height = 320;
        });
      }
    }

    // ── Lenis Smooth Scroll ──
    const lenis = new Lenis({
      duration: 1.2,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      revealObserver.disconnect();
      lenis.destroy();
    };
  }, []);

  const toggleDay = (e: React.MouseEvent<HTMLDivElement>) => {
    const parent = e.currentTarget.parentElement;
    if (parent) {
      const header = parent.querySelector('.tl-day-header');
      const body = parent.querySelector('.tl-day-body');

      if (header && body) {
        header.classList.toggle('open');
        body.classList.toggle('open');
      }
    }
  };

  return (
    <>
      <BackgroundMusic />
      <header>
        <FloatingNav navItems={navItems} />
      </header>

      <div className="cursor hidden md:block">
        <div className="cursor-dot" id="dot"></div>
        <div className="cursor-ring" id="ring"></div>
      </div>

      <main>
        {/* ══════ HERO ══════ */}
        <section className="hero" id="hero" style={{ position: 'relative', overflow: 'hidden' }}>
          {/* Vimeo background video */}
          <div style={{ position: 'absolute', inset: 0, zIndex: 0, overflow: 'hidden' }}>
            <iframe
              src="https://player.vimeo.com/video/1171551523?background=1&autoplay=1&loop=1&muted=1&title=0&byline=0&portrait=0&controls=0"
              allow="autoplay; fullscreen"
              referrerPolicy="strict-origin-when-cross-origin"
              title="Vídeo de fundo do Encontro Nacional Templário"
              style={{ position: 'absolute', top: '50%', left: '50%', width: 'max(177.78vh, 100%)', height: 'max(56.25vw, 100%)', transform: 'translate(-50%, -50%)', border: 'none' }}
            />
          </div>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.55)', zIndex: 1 }} />

          <div className="corner tl"></div>
          <div className="corner tr"></div>
          <div className="corner bl"></div>
          <div className="corner br"></div>

          <div className="hero-inner" style={{ position: 'relative', zIndex: 2 }}>
            {/* ESQUERDA: Conteúdo principal */}
            <div className="hero-content">
              <div className="eyebrow">
                {t('hero.eyebrow_main', 'Gran Priorato Templário do Brasil · Cavalaria Espiritual São João Batista')}
                <span className="eyebrow-sub">
                  {t('hero.eyebrow_sub', 'OSMTH Brasil · OSMTH Magnum Magisterium')}
                </span>
              </div>

              <h1 className="title">
                {t('hero.title_main', 'Encontro Nacional Templário de')}<br />
                <span className="highlight">
                  {t('hero.title_highlight', 'Escudeiros, Damas e Cavaleiros')}
                </span>
              </h1>

              <p className="subtitle">
                {t('hero.subtitle', 'Uma jornada espiritual de reencontro com nossos votos e a essência da Ordem.')}
              </p>

              <div className="info-row">
                <div className="info-block">
                  <span className="label">{t('hero.date_label', 'Data')}</span>
                  <span className="value">{t('hero.date_value', '19 a 22 de Março')}</span>
                </div>
                <div className="info-sep"></div>
                <div className="info-block">
                  <span className="label">A.T.</span>
                  <span className="value">908</span>
                </div>
                <div className="info-sep"></div>
                <div className="info-block">
                  <span className="label">A.D.</span>
                  <span className="value">2026</span>
                </div>
                <div className="info-sep"></div>
                <div className="info-block">
                  <span className="label">{t('hero.location_label', 'Local')}</span>
                  <span className="value">{t('hero.location_value', 'Rio de Janeiro — RJ')}</span>
                </div>
              </div>

              <div className="cta-row">
                <a href="#programacao" className="btn-primary" style={{ textDecoration: 'none' }}><span>{t('hero.cta', 'Ver Programação')}</span></a>
              </div>
            </div>

            {/* DIREITA: Cruz Templária */}
            <div className="hero-emblem">
              <div className="cross-wrap">
                <div className="cross-container">
                  <img src={cruzTemplaria} alt="Cruz Templária" style={{ width: '100%', height: '100%' }} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="bg-white pt-4 pb-0 border-t border-gray-100">
          <React.Suspense fallback={<div style={{ height: 100 }}></div>}>
            <CountdownTimer />
          </React.Suspense>
        </div>

        <section className="sobre" id="sobre">
          <div className="sobre-inner">
            {/* Header: tag + title */}
            <div className="sobre-text">
              <div className="sobre-tag">{t('about.tag', 'O Propósito do Encontro')}</div>
              <h2 className="sobre-heading">
                {t('about.heading', 'O chamado ressurge')}<br />
                <span>{t('about.heading_span', 'através dos tempos.')}</span>
              </h2>
            </div>

            {/* Video — centrado e maior */}
            <div className="video-wrap">
              <div className="video-frame"></div>
              <VimeoPlayer videoId="1169768697" />
            </div>

            {/* Body text below */}
            <div className="sobre-body">
              <div className="sobre-divider"></div>
              <p className="sobre-msg">
                {t('about.msg', 'Este encontro reúne Escudeiros, Irmãos Cavaleiros e Irmãs Damas onde a fé abraça a história, fortalecendo a alma templária forjada na fraternidade.')}
              </p>
              <div className="sobre-realizacao">
                <span className="sobre-realizacao-label">{t('about.realization', 'Realização')}</span>
                <span className="sobre-realizacao-value">
                  Gran Priorato Templário do Brasil
                  <span className="osmth-sub">OSMTH Magnum Magisterium</span>
                </span>
              </div>
            </div>
          </div>
          <div className="sobre-stripe"></div>
        </section>

        {/* ══════ AUTORIDADES ══════ */}
        <section className="autoridades" id="autoridades">
          <div className="aut-container">
            <div className="section-header">
              <div className="section-tag">{t('authorities.tag', 'Presenças de Honra')}</div>
              <h2 className="section-title">{t('authorities.title', 'Autoridades e')}<br /><span>{t('authorities.title_span', 'Lideranças da Ordem')}</span></h2>
            </div>

            <Carousel
              className="w-full mx-auto max-w-[90vw] md:max-w-4xl xl:max-w-7xl mt-8"
              opts={{
                align: "start",
                dragFree: true
              }}
            >
              <CarouselContent>
                <CarouselItem className="pl-4 basis-[85%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <div className="aut-card h-full">
                    <div className="aut-photo">
                      <img src={imgAlbino} alt="Dom Albino Neves" className="aut-photo-img" loading="lazy" decoding="async" width="300" height="400" />
                    </div>
                    <div className="aut-info">
                      <div className="aut-name">Dom Albino Neves</div>
                      <div className="aut-role">{t('authorities.roles.grao_mestre', 'Grão Mestre da Ordem')}</div>
                    </div>
                  </div>
                </CarouselItem>

                <CarouselItem className="pl-4 basis-[85%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <div className="aut-card h-full">
                    <div className="aut-photo">
                      <img src={imgFernando} alt="Fernando Alves Bacellar" className="aut-photo-img" loading="lazy" decoding="async" width="300" height="400" />
                    </div>
                    <div className="aut-info">
                      <div className="aut-name">Fernando Alves Bacellar</div>
                      <div className="aut-role">{t('authorities.roles.grao_prior', 'Gran Prior Magistral do Brasil')}</div>
                    </div>
                  </div>
                </CarouselItem>

                <CarouselItem className="pl-4 basis-[85%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <div className="aut-card h-full">
                    <div className="aut-photo">
                      <img src={imgRaymond} alt="Raymond Chomette" className="aut-photo-img" loading="lazy" decoding="async" width="300" height="400" />
                    </div>
                    <div className="aut-info">
                      <div className="aut-name">{t('authorities.roles.raymond_name')}</div>
                      <div className="aut-role">{t('authorities.roles.raymond_role', { interpolation: { escapeValue: false } })}</div>
                    </div>
                  </div>
                </CarouselItem>

                <CarouselItem className="pl-4 basis-[85%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <div className="aut-card h-full">
                    <div className="aut-photo">
                      <img src={imgSideni} alt="Sidení Morateli" className="aut-photo-img" loading="lazy" decoding="async" width="300" height="400" />
                    </div>
                    <div className="aut-info">
                      <div className="aut-name">Sidení Morateli</div>
                      <div className="aut-role">{t('authorities.roles.prior_sul', 'Magnum Crux')}</div>
                    </div>
                  </div>
                </CarouselItem>

                <CarouselItem className="pl-4 basis-[85%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <div className="aut-card h-full">
                    <div className="aut-photo">
                      <img src={imgAparecida} alt="Aparecida Santana" className="aut-photo-img" loading="lazy" decoding="async" width="300" height="400" />
                    </div>
                    <div className="aut-info">
                      <div className="aut-name">Aparecida Santana</div>
                      <div className="aut-role">{t('authorities.roles.prioresa_mg', 'Prioresa de Minas Gerais')}</div>
                    </div>
                  </div>
                </CarouselItem>

                <CarouselItem className="pl-4 basis-[85%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <div className="aut-card h-full">
                    <div className="aut-photo">
                      <img src={imgRegente} alt="Clayton Serrinha Guedes" className="aut-photo-img" loading="lazy" decoding="async" width="300" height="400" />
                    </div>
                    <div className="aut-info">
                      <div className="aut-name">{t('authorities.roles.clayton_name', 'Clayton Serrinha Guedes')}</div>
                      <div className="aut-role">{t('authorities.roles.clayton_role', { interpolation: { escapeValue: false } })}</div>
                    </div>
                  </div>
                </CarouselItem>
              </CarouselContent>
              <CarouselPrevious className="hidden lg:flex text-white border-white bg-transparent hover:bg-white/10" />
              <CarouselNext className="hidden lg:flex text-white border-white bg-transparent hover:bg-white/10" />
              <div className="mt-8 flex justify-center">
                <CarouselDots />
              </div>
            </Carousel>
          </div>
        </section>

        {/* ══════ PROGRAMAÇÃO ══════ */}
        <section className="programacao" id="programacao">
          <div className="prog-container">
            <div className="prog-section-tag">{t('program.tag', 'Cronograma Oficial')}</div>
            <h2 className="prog-section-title">{t('program.title', 'Programação')} <span>{t('program.title_span', 'Oficial')}</span></h2>

            <div className="timeline" id="timeline">
              {/* DIA 19 */}
              <div className="tl-day">
                <div className="tl-day-header open" onClick={toggleDay}>
                  <span className="tl-day-date">19 / 03 / 2026</span>
                  <span className="tl-day-name">{t('program.thursday', 'Quinta-feira · Abertura')}</span>
                  <span className="tl-chevron">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </div>
                <div className="tl-day-body open">
                  <div className="tl-events">
                    <div className="tl-event">
                      <span className="tl-time">18:00h</span>
                      <span className="tl-desc">
                        {t('program.events.credenciamento', 'Início do credenciamento e coquetel de boas-vindas')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L8 6H4l2 14h12L20 6h-4L12 2z" />
                          </svg>
                          {t('dress_code.levels.casual', 'Casual')}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* DIA 20 */}
              <div className="tl-day">
                <div className="tl-day-header" onClick={toggleDay}>
                  <span className="tl-day-date">20 / 03 / 2026</span>
                  <span className="tl-day-name">{t('program.friday', 'Sexta-feira · Cerimônia')}</span>
                  <span className="tl-chevron">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </div>
                <div className="tl-day-body">
                  <div className="tl-events">
                    <div className="tl-event">
                      <span className="tl-time">08:00 – 10:00h</span>
                      <span className="tl-desc">
                        {t('program.events.cafe', 'Café da manhã')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L8 6H4l2 14h12L20 6h-4L12 2z" />
                          </svg>
                          {t('dress_code.levels.casual_light', 'Casual (roupas leves)')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">10:00 – 12:00h</span>
                      <span className="tl-desc">
                        {t('program.events.free_time', 'Manhã livre para explorar o Rio de Janeiro')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L8 6H4l2 14h12L20 6h-4L12 2z" />
                          </svg>
                          {t('dress_code.levels.casual_light', 'Casual (roupas leves)')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">12:00h</span>
                      <span className="tl-desc">{t('program.events.almoco', 'Almoço (não incluso)')}</span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">13:00h</span>
                      <span className="tl-desc">
                        {t('program.events.traslado', 'Pontualmente na porta do hotel — traslado para a igreja para a palestra')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="1" />
                            <path d="M9 3v18M15 3v18" />
                          </svg>
                          {t('dress_code.levels.formal_manto', 'Formal c/ Manto, Luvas, Joias e Venera')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">14:00 – 15:45h</span>
                      <span className="tl-desc">
                        <strong>NA IGREJA:</strong><br />
                        Palestra: {t('program.events.painel_titulo', '"Visão Histórica da Influência Templária no Desenvolvimento do Brasil"')} — Prior do Sul ++ Sideni Moratelli
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="1" />
                            <path d="M9 3v18M15 3v18" />
                          </svg>
                          {t('dress_code.levels.formal_manto', 'Formal c/ Manto, Luvas, Joias e Venera')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">16:00 – 17:00h</span>
                      <span className="tl-desc">
                        Painel com a participação do Grão Mestre Dom Albino Neves e o Gran Prior Magistral do Brasil ++ Fernando Bacellar
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="1" />
                            <path d="M9 3v18M15 3v18" />
                          </svg>
                          {t('dress_code.levels.formal_manto', 'Formal c/ Manto, Luvas, Joias e Venera')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">17:00 – 18:00h</span>
                      <span className="tl-desc">{t('program.events.organizacao', 'Breve intervalo e organização e formação da procissão de entrada na igreja')}</span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">18:00 – 20:00h</span>
                      <span className="tl-desc">
                        <strong>{t('program.events.investidura', 'Conventus Templi e Cerimônia de Nomeação')}</strong>
                        <span className="tl-dress">
                          <svg viewBox="0 0 90 120" fill="none" stroke="currentColor" strokeWidth="5">
                            <path d="M38 8 L52 8 L52 30 L82 30 L82 42 L52 42 L52 62 L72 62 L72 74 L52 74 L52 112 L38 112 L38 74 L18 74 L18 62 L38 62 L38 42 L8 42 L8 30 L38 30 Z" />
                          </svg>
                          {t('dress_code.levels.formal_manto', 'Formal c/ Manto, Luvas, Joias e Venera')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">20:00 – 21:30h</span>
                      <span className="tl-desc">{t('program.events.coquetel', 'Coquetel incluso para os inscritos do encontro')}</span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">21:30h</span>
                      <span className="tl-desc">{t('program.events.translado_hotel_dia20', 'Traslado de volta para o hotel')}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* DIA 21 */}
              <div className="tl-day">
                <div className="tl-day-header" onClick={toggleDay}>
                  <span className="tl-day-date">21 / 03 / 2026</span>
                  <span className="tl-day-name">{t('program.saturday', 'Sábado · Encontro Nacional')}</span>
                  <span className="tl-chevron">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </div>
                <div className="tl-day-body">
                  <div className="tl-events">
                    <div className="tl-event">
                      <span className="tl-time">06:00 – 08:00h</span>
                      <span className="tl-desc">
                        {t('program.events.cafe', 'Café da manhã')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L8 6H4l2 14h12L20 6h-4L12 2z" />
                          </svg>
                          {t('dress_code.levels.casual_light', 'Casual (roupas leves)')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">08:00 – 09:00h</span>
                      <span className="tl-desc">
                        {t('program.events.preparar_cristo', 'Se arrumar para a saída para o Cristo Redentor')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M2 20h20M12 4v16M7 9l5-5 5 5" />
                          </svg>
                          {t('dress_code.levels.formal_parcial_manto', 'Formal Parcial c/ Manto, Luvas, Joias e Venera')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">09:00h</span>
                      <span className="tl-desc">{t('program.events.van_cristo', 'Pontualmente na porta do hotel — van para o Cristo Redentor')}</span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">09:00 – 12:00h</span>
                      <span className="tl-desc">
                        {t('program.events.cristo', 'Visita ao Cristo Redentor')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M2 20h20M12 4v16M7 9l5-5 5 5" />
                          </svg>
                          {t('dress_code.levels.formal_parcial_manto', 'Formal Parcial c/ Manto, Luvas, Joias e Venera')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">12:00 – 15:00h</span>
                      <span className="tl-desc">{t('program.events.almoco', 'Almoço (não incluso)')} e {t('program.events.descanso', 'descanso no Hotel Vila Galé')}.</span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">15:00 – 16:00h</span>
                      <span className="tl-desc">
                        {t('program.events.conversa', 'Conversa (bate papo) com a liderança')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L8 6H4l2 14h12L20 6h-4L12 2z" />
                          </svg>
                          {t('dress_code.levels.casual', 'Casual')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">16:00 – 17:00h</span>
                      <span className="tl-desc">
                        {t('program.events.intervalo', 'Intervalo para café')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L8 6H4l2 14h12L20 6h-4L12 2z" />
                          </svg>
                          {t('dress_code.levels.casual', 'Casual')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">18:00 – 20:00h</span>
                      <span className="tl-desc">
                        <strong>{t('program.events.encontro_nacional', 'Encontro Nacional Templário')}</strong> {t('program.events.beija_flor', '(sala de eventos Beija Flor)')}
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="1" />
                            <path d="M9 3v18M15 3v18" />
                          </svg>
                          {t('dress_code.levels.formal_manto', 'Formal c/ Manto, Luvas, Joias e Venera')}
                        </span>
                      </span>
                    </div>
                    <div className="tl-event">
                      <span className="tl-time">20:30 – 22:30h</span>
                      <span className="tl-desc">
                        <strong>{t('program.events.jantar_gala', 'Jantar de Gala')}</strong>
                        <span className="tl-dress">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                          </svg>
                          {t('dress_code.levels.gala', 'Gala')}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* DIA 22 */}
              <div className="tl-day">
                <div className="tl-day-header" onClick={toggleDay}>
                  <span className="tl-day-date">22 / 03 / 2026</span>
                  <span className="tl-day-name">{t('program.sunday', 'Domingo · Encerramento')}</span>
                  <span className="tl-chevron">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </div>
                <div className="tl-day-body">
                  <div className="tl-events">
                    <div className="tl-event">
                      <span className="tl-time">08:00 – 09:00h</span>
                      <span className="tl-desc">
                        Café da manhã no Hotel
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="section-divider"></div>

        {/* ══════ DRESS CODE ══════ */}
        <section className="dresscode" id="dresscode">
          <div className="dc-container">
            <div className="section-header">
              <div className="section-tag">{t('dress_code.tag', 'Guia de Trajes')}</div>
              <h2 className="section-title">{t('dress_code.title', 'Dress Code')} <span>{t('dress_code.title_span', 'Oficial')}</span></h2>
            </div>

            <div className="dc-grid">
              {/* CARTÃO 1: TRAJE CASUAL */}
              <div className="dc-card reveal-item">
                <div className="dc-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="12" cy="7" r="4" />
                    <path d="M5 21v-1a7 7 0 0 1 14 0v1" />
                  </svg>
                </div>
                <div className="dc-body">
                  <div className="dc-level">{t('dress_code.levels.casual', 'Traje Casual')}</div>
                  <div className="dc-occasion">{t('dress_code.occasions.casual', 'Recepção, Cadastro, Cafés da manhã, Passeios e Palavras do Gran-Mestre')}</div>
                  <div className="dc-desc">{t('dress_code.descriptions.casual', 'Roupas leves pois o clima é quente: calça, saia ou shorts, camiseta/camisa, e calçados confortáveis (tênis/sandálias).')}</div>
                </div>
              </div>

              {/* CARTÃO 2: TRAJE FORMAL PARCIAL */}
              <div className="dc-card reveal-item">
                <div className="dc-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                  </svg>
                </div>
                <div className="dc-body">
                  <div className="dc-level">{t('dress_code.levels.formal_parcial', 'Traje Formal Parcial')}</div>
                  <div className="dc-occasion">{t('dress_code.occasions.formal_parcial', 'Visita ao Cristo Redentor')}</div>
                  <div className="dc-desc">{t('dress_code.descriptions.formal_parcial_manto', 'Calça preta, camisa branca, gravata preta, sapatos e meia preta + manto com Luvas, Joias e Veneras.')}</div>
                </div>
              </div>

              {/* CARTÃO 3: TRAJE FORMAL */}
              <div className="dc-card reveal-item">
                <div className="dc-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <rect x="3" y="3" width="18" height="18" rx="1" />
                    <path d="M9 3v18M15 3v18" />
                  </svg>
                </div>
                <div className="dc-body">
                  <div className="dc-level">{t('dress_code.levels.formal', 'Traje Formal')}</div>
                  <div className="dc-occasion">{t('dress_code.occasions.formal', 'Na Igreja (Conventus Templi) e Cerimônia de Nomeação')}</div>
                  <div className="dc-desc">{t('dress_code.descriptions.formal_manto', 'Terno ou conjunto preto, camisa branca, gravata preta, sapatos e meia preta + manto com Luvas, Joias e Veneras.')}</div>
                </div>
              </div>

              {/* CARTÃO 4: GALA */}
              <div className="dc-card reveal-item">
                <div className="dc-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                </div>
                <div className="dc-body">
                  <div className="dc-level">{t('dress_code.levels.gala', 'Gala')}</div>
                  <div className="dc-occasion">{t('dress_code.occasions.gala', 'Jantar de Gala')}</div>
                  <div className="dc-desc">{t('dress_code.descriptions.gala', 'Homens de terno, Mulheres de vestido ou conjuntos.')}</div>
                </div>
              </div>

              {/* A imagem foi removida pois os 4 cartões de traje preenchem o grid uniformemente. */}
            </div>
          </div>
        </section>

        {/* ══════ INFORMAÇÕES PRÁTICAS ══════ */}
        <section className="infopratica" id="local">
          <div className="info-container">
            <div className="prog-section-tag">{t('practical.tag', 'Logística')}</div>
            <h2 className="prog-section-title">{t('practical.title', 'Informações')} <span>{t('practical.title_span', 'Práticas')}</span></h2>

            <div className="info-grid">
              <div className="reveal-item">
                <div className="info-block-section">
                  <h3>{t('practical.hospedagem', 'Hospedagem Recomendada')}</h3>

                  <div className="hotel-card">
                    <div className="hotel-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        <polyline points="9 22 9 12 15 12 15 22" />
                      </svg>
                    </div>
                    <div className="hotel-info">
                      <div className="hotel-name">Hotel Vila Galé Rio de Janeiro</div>
                      <div className="hotel-phone">(21) 2460-4500</div>
                    </div>
                  </div>

                  <div className="hotel-card">
                    <div className="hotel-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        <polyline points="9 22 9 12 15 12 15 22" />
                      </svg>
                    </div>
                    <div className="hotel-info">
                      <div className="hotel-name">Casa Nova Hotel</div>
                      <div className="hotel-phone">(21) 3547-5241</div>
                    </div>
                  </div>

                  <div className="hotel-card">
                    <div className="hotel-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        <polyline points="9 22 9 12 15 12 15 22" />
                      </svg>
                    </div>
                    <div className="hotel-info">
                      <div className="hotel-name">Fluminense Hotel</div>
                      <div className="hotel-phone">(21) 9.8498-0361</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="reveal-item" style={{ transitionDelay: '0.15s' }}>
                <div className="info-block-section">
                  <h3>{t('practical.logistica', 'Logística')}</h3>
                  <div className="logistics-box">
                    <p>{t('practical.logistics_box', 'Haverá van e apoio organizacional para o trajeto até o Cristo Redentor. Vagas para certos atos são limitadas.')}</p>
                  </div>
                </div>

                <div className="info-block-section" style={{ marginTop: '2.5rem' }}>
                  <h3>{t('practical.localizacao', 'Localização do evento')}</h3>
                  <div className="hotel-address" style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#1a1210' }}>
                    <strong>{t('practical.endereco', 'Endereço')}:</strong> R. Riachuelo, 124 - Centro, Rio de Janeiro - RJ, 20230-014
                  </div>
                  <div className="map-container" style={{ width: '100%', height: '250px', borderRadius: '8px', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.1)' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=R.%20Riachuelo%2C%20124%20-%20Centro%2C%20Rio%20de%20Janeiro%20-%20RJ%2C%2020230-014&z=15&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      title="Mapa - Hotel Vila Galé Rio de Janeiro"
                      referrerPolicy="strict-origin-when-cross-origin"
                    ></iframe>
                  </div>
                  <a
                    href="https://maps.google.com/?q=R.%20Riachuelo%2C%20124%20-%20Centro%2C%20Rio%20de%20Janeiro%20-%20RJ%2C%2020230-014"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'inline-block', marginTop: '0.75rem', fontSize: '0.9rem', textDecoration: 'underline' }}
                  >
                    {t('practical.abrir_maps', 'Abrir no Google Maps')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="section-divider"></div>

        {/* ══════ BRASÕES ══════ */}
        <section className="brasoes" id="heraldica">
          <div className="brasoes-container">
            <div className="section-header">
              <div className="section-tag">{t('heraldry.tag', 'Heráldica')}</div>
              <h2 className="section-title">{t('heraldry.title', 'Brasões')} <span>{t('heraldry.title_span', 'da Ordem')}</span></h2>
            </div>

            <div className="brasoes-grid">
              <div className="brasao-item reveal-item">
                <div className="brasao-frame">
                  <img
                    src={brasaoMagistral}
                    alt="Brasão Mundial"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </div>
                <div className="brasao-caption">
                  <div className="brasao-caption-title">{t('heraldry.caption_magistral', 'Brasão Mundial')}</div>
                  <div className="brasao-caption-sub">{t('heraldry.sub_magistral', 'OSMTH - Magnum Magisterium \nLiderança mundial')}</div>
                </div>
              </div>

              <div className="brasao-item reveal-item" style={{ transitionDelay: '0.1s' }}>
                <div className="brasao-frame">
                  <img
                    src={brasaoBrasil}
                    alt="Brasão do Brasil"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </div>
                <div className="brasao-caption">
                  <div className="brasao-caption-title">{t('heraldry.caption_brasil', 'Brasão do Brasil')}</div>
                  <div className="brasao-caption-sub">{t('heraldry.sub_brasil', 'Gran Priorato Templário do Brasil \nLiderança Nacional')}</div>
                </div>
              </div>

              <div className="brasao-item reveal-item" style={{ transitionDelay: '0.2s' }}>
                <div className="brasao-frame">
                  <img
                    src={brasaoRJ}
                    alt="Brasão CTSMARJ"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </div>
                <div className="brasao-caption">
                  <div className="brasao-caption-title">{t('heraldry.brasao_rj', 'Brasão Estadual do Rio de janeiro')}</div>
                  <div className="brasao-caption-sub">{t('heraldry.sub_rj', 'Comendadoria Templária São Miguel Arcanjo \nRio de Janeiro / RJ')}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="section-divider"></div>

        {/* ══════ GALERIA ══════ */}
        <section className="brasoes" id="galeria">
          <div className="brasoes-container">
            <div className="section-header">
              <div className="section-tag">{t('gallery.tag', 'Registro do Evento')}</div>
              <h2 className="section-title">{t('gallery.title', 'Galeria')} <span>{t('gallery.title_span', 'de Fotos')}</span></h2>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
              gap: 'clamp(12px, 2vw, 20px)',
              maxWidth: 960,
              margin: '0 auto',
            }}>
              {[0, 1, 2, 3].map((idx) => (
                <div key={idx} className="brasao-frame placeholder reveal-item" style={{
                  transitionDelay: `${0.1 + idx * 0.08}s`,
                  aspectRatio: '4/3',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 10,
                }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: 'var(--gold)', opacity: 0.3 }}>
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                    <circle cx="9" cy="9" r="2" />
                    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                  </svg>
                  <span style={{
                    color: 'var(--gold)',
                    opacity: 0.4,
                    fontFamily: "'Times New Roman', Times, serif",
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    letterSpacing: '0.15em',
                    textTransform: 'uppercase',
                  }}>
                    {t('gallery.coming_soon', 'Em breve')}
                  </span>
                </div>
              ))}
            </div>

            <div style={{ textAlign: 'center', marginTop: 'clamp(24px, 4vw, 40px)' }}>
              <a
                href="/galeria"
                className="reveal-item"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  color: 'var(--gold)',
                  fontFamily: "'Times New Roman', Times, serif",
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  border: '1px solid rgba(201, 168, 76, 0.3)',
                  padding: '12px 28px',
                  borderRadius: 50,
                  transition: 'all 0.3s',
                }}
              >
                {t('gallery.see_all', 'Ver todas as fotos')}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14m-7-7 7 7-7 7" /></svg>
              </a>
            </div>
          </div>
        </section>

        <div className="section-divider"></div>

        {/* ══════ COORDENAÇÃO ══════ */}
        <section id="coordenacao" className="brasoes">
          <div className="brasoes-container" style={{ maxWidth: 900 }}>
            <div className="section-header">
              <div className="section-tag">{t('coordination.tag', 'Equipe Organizadora')}</div>
              <h2 className="section-title">{t('coordination.title', 'Coordenação do')} <span>{t('coordination.title_span', 'Encontro Nacional Templário')}</span></h2>
              <p className="section-tag" style={{ marginTop: 8 }}>Rio de Janeiro — 2026</p>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: 16,
              maxWidth: 700,
              margin: '0 auto',
            }}>
              {[
                'Clayton Serrinha Guedes',
                'Fernando Alves Bacellar',
                'Jorge Alexandre Rodrigues',
                'Marco Aurélio Koerich',
                'Maria Aparecida Santana',
                'Natanael Kiljander',
                'Sideni Moratelli',
                'Solange Pazini',
              ].map((name, idx) => (
                <div key={name} className="reveal-item" style={{
                  transitionDelay: `${0.1 + idx * 0.06}s`,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  padding: '16px 20px',
                  border: '1px solid rgba(255,255,255,0.06)',
                  borderRadius: 12,
                  background: 'rgba(255,255,255,0.02)',
                }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#c9a84c', flexShrink: 0, opacity: 0.7 }} />
                  <span style={{ color: 'rgba(255,255,255,0.8)', fontFamily: "'Times New Roman', Times, serif", fontSize: 'clamp(0.95rem, 1.5vw, 1.1rem)', fontWeight: 600, letterSpacing: '0.02em' }}>
                    {name}
                  </span>
                </div>
              ))}
            </div>

          </div>
        </section>

        {/* ══════ FOOTER / CONTATO ══════ */}
      </main>
      <footer className="footer" id="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="footer-cross">
              <img src={cruzTemplaria} alt="Cruz Templária" style={{ width: '100%', height: '100%' }} />
            </div>
            <div className="footer-brand-name">
              {t('footer.brand_name', 'Gran Priorato Templário do Brasil')}
              <span className="osmth-sub">OSMTH Magnum Magisterium</span>
            </div>
          </div>

          <div className="footer-contact">
            <div className="footer-contact-label">{t('footer.contact_label', 'Contato Oficial')}</div>
            <p className="footer-support-text">{t('footer.support_text', 'Para informações e suporte sobre o evento, fale com nossa comissão — Sidení Morateli.')}</p>
            <a href="https://wa.me/5541991024344" target="_blank" rel="noopener noreferrer" className="footer-whatsapp">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a5.8 5.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
              WhatsApp
            </a>
          </div>

          <div className="footer-closing">
            <div className="footer-closing-quote">
              {t('footer.quote', '"A verdadeira força não reside na espada, mas no espírito."')}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{t('footer.copyright', '© 2026 Encontro Nacional Templário. Todos os direitos reservados.')}</span>
          <span className="footer-bottom-motto hidden md:inline-block">{t('footer.motto_full', 'Non Nobis Domine, Non Nobis, Sed Nomini Tuo Da Gloriam')}</span>
        </div>
      </footer>

      {/* ══════ DESENVOLVEDOR ══════ */}
      <div className="dev-bar">
        <div className="dev-left">
          <span>{t('footer.developed_by', 'Desenvolvido por')}</span>
          <a href="https://www.vislume.com.br/?utm_source=clients&utm_medium=footer" target="_blank" rel="noopener noreferrer">Vislume</a>
        </div>
        <a href="https://wa.me/5537998451517" target="_blank" rel="noopener noreferrer" className="dev-whatsapp">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a5.8 5.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
          {t('footer.talk_to_dev', 'Fale com o Desenvolvedor')}
        </a>
      </div>
    </>
  );
};

export default Index;
